// RippleButton.js
import React from "react";

const RippleButton = ({ onClick, isLoading, children, type }) => {
  return (
    <button
      type={type}
      className="btn-ripple mbot-btn-primary center-alignment"
      onClick={onClick}
      disabled={isLoading}
    >
      {isLoading ? <span className="loader"></span> : children}
    </button>
  );
};

export default RippleButton;
